<template>
    <div class="widget" v-bind:class="[{'loaded':loaded},className]" v-if="$aclInterfaceValidator('weeboxshop.order.statsca')">

        <header class="widget-header">
            <h2 class="widget-title">{{ title }}</h2>
            <h3 class="widget-title-period">
                <span v-for="item in periods" v-if="item.id == period">{{ item.label }}</span>
            </h3>

            <div class="widget-actions-container">
                <div><form-toggle label="" v-model="is_ttc" label-true="TTC" label-false="HT"></form-toggle></div>
                <widget-dropdown v-model="period" :options="periods" :callback="filterByPeriod"></widget-dropdown>
            </div>

            <div class="form-advanced-filter" v-if="showAdvancedFilterVue">
                <span>Filtrer par date</span>
                <div class="date-filters">
                    <form-datex label="du" v-model="dateFilter.start_at" :hide-time="true" time="00:00:00"></form-datex>
                    <form-datex label="au" v-model="dateFilter.end_at" :hide-time="true" time="23:59:59"></form-datex>
                </div>
            </div>


        </header>

        <div class="widget-preloader">
            <div class="pre-loader">
                <div class="box1"></div>
                <div class="box2"></div>
                <div class="box3"></div>
                <div class="box4"></div>
                <div class="box5"></div>
            </div>
        </div>

        <div class="widget-content" v-if="count != null">
            <div class="widget-content">

              <div class="data-labels">
                <div class="data-label main" v-if="is_ttc">
                  <strong><i class="currency">{{ currency }}<span>TTC</span></i> {{ total|formatNumber }}</strong>
                  <span class="legend">Total CA TTC</span>
                  <span class="compare-to-previous">
                    <compare :previous="total_compare" :current="total" :currency="currency"></compare>
                  </span>
                </div>
                <div class="data-label main" style="margin: auto;display: inline-block;padding-right: 40px;width: auto;" v-if="!is_ttc">
                  <strong><i class="currency">{{ currency }}<span>HT</span></i> {{ total_ht|formatNumber }}</strong>
                  <span class="legend">Total CA HT</span>
                  <span class="compare-to-previous">
                    <compare :previous="total_compare_ht" :current="total_ht" :currency="currency"></compare>
                  </span>
                </div>
                <div class="data-label">
                  <strong>{{ count }}</strong>
                  <span class="legend">Nbre de ventes</span>
                  <span class="compare-to-previous">
                    <compare :previous="count_compare" :current="count"></compare>
                  </span>
                </div>
              </div>

              <div style="width:100%;display:flex;align-items: center;justify-content:space-between;">
                <div class="data-circle" style="width:50%;">
                  <!--<span class="data-percentage">{{ Math.round((total_paied*100/total)) }}%</span>-->
                  <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=" width="100%" height="100%">

                  <svg class='ten-percent' x="0px" y="0px" viewBox="0 0 142.924 142.924" enable-background="new 0 0 142.924 142.924" xml:space="preserve" v-for="(pie, index) in pieChart" v-bind:style="{width: (100-((80/pieChart.length) * index) + index)+'%', height: (100-((80/pieChart.length) * index) + index)+'%'}">
                    <path fill="none" class="background" :stroke="pie.background?pie.background:'#f2f2f2'" :stroke-width="49" :stroke-miterlimit="49" d="M71.462,13.129
                    c32.217,0,58.334,26.116,58.334,58.333s-26.117,58.334-58.334,58.334s-58.333-26.117-58.333-58.334S39.245,13.129,71.462,13.129" :rel="20 - (20 * (100-((80/pieChart.length) * index)) / 100)"/>
                    <path fill="none" class="target" :stroke="pie.color" :stroke-width="49" :stroke-miterlimit="49" :stroke-dasharray="((pie.value)*365/100)+'px 1000px'" d="M71.462,13.129
                    c32.217,0,58.334,26.116,58.334,58.333s-26.117,58.334-58.334,58.334s-58.333-26.117-58.333-58.334S39.245,13.129,71.462,13.129"/>
                  </svg>

                </div>
                <div style="width:50%;">
                  <div>
                    <span class="data-legend"><i style="background:#86d055;"></i> Montants payés</span>
                    <div style="display:flex;flex-direction:column;">
                      <div class="data-label small" v-if="is_ttc">
                        <strong><i class="currency">{{ currency }}<span>TTC</span></i> {{ total_paied|formatNumber }}</strong>
                      </div>
                      <div class="data-label small" v-if="!is_ttc">
                        <strong><i class="currency">{{ currency }}<span>HT</span></i> {{ total_paied_ht|formatNumber }}</strong>
                      </div>
                    </div>
                  </div>
                  <div style="margin-top: 15px;">
                    <span class="data-legend"><i style="background:#f7d46b;"></i> Montants ouverts</span>
                    <div style="display:flex;flex-direction:column;">
                      <div class="data-label small" v-if="is_ttc">
                        <strong><i class="currency">{{ currency }}<span>TTC</span></i> {{ total_pending|formatNumber }}</strong>
                      </div>
                      <div class="data-label small" v-if="!is_ttc">
                        <strong><i class="currency">{{ currency }}<span>HT</span></i> {{ total_pending_ht|formatNumber }}</strong>
                      </div>
                    </div>
                  </div>

                  <!-- SALES -->
                  <div style="margin-top: 15px;">
                    <span class="data-legend"><i style="background:rgb(103, 178, 255);"></i> Vente directe</span>
                    <div style="display:flex;flex-direction:column;">
                      <div class="data-label small" v-if="is_ttc">
                        <strong><i class="currency">{{ currency }}<span>TTC</span></i> {{ direct_total|formatNumber }}</strong>
                      </div>
                      <div class="data-label small" v-if="!is_ttc">
                        <strong><i class="currency">{{ currency }}<span>HT</span></i> {{ direct_total_ht|formatNumber }}</strong>
                      </div>
                    </div>
                  </div>

                  <div style="margin-top: 15px;">
                    <span class="data-legend"><i style="background:rgb(192, 81, 255);"></i> Vente Web</span>
                    <div style="display:flex;flex-direction:column;">
                      <div class="data-label small" v-if="is_ttc">
                        <strong><i class="currency">{{ currency }} <span>TTC</span></i> {{ ecommerce_total|formatNumber }}</strong>
                      </div>
                      <div class="data-label small" v-if="!is_ttc">
                        <strong><i class="currency">{{ currency }} <span>TTC</span></i> {{ ecommerce_total_ht|formatNumber }}</strong>
                      </div>

                      <!--
                      <div class="data-label small" v-if="is_ttc">
                        <strong style="font-size: 1rem;"><i class="currency">Existants</i> {{ ecommerce_existing_total|formatNumber }} / {{ ecommerce_existing_count }}</strong>
                      </div>
                      <div class="data-label small" v-if="!is_ttc">
                        <strong style="font-size: 1rem;"><i class="currency">Existants</i> {{ ecommerce_existing_total_ht|formatNumber }} / {{  ecommerce_existing_count }}</strong>
                      </div>

                      <div class="data-label small" v-if="is_ttc">
                        <strong style="font-size: 1rem;"><i class="currency">Nouveaux</i> {{ ecommerce_total - ecommerce_existing_total|formatNumber }} / {{ ecommerce_count - ecommerce_existing_count }}</strong>
                      </div>
                      <div class="data-label small" v-if="!is_ttc">
                        <strong style="font-size: 1rem;"><i class="currency">Nouveaux</i> {{ ecommerce_total_ht - ecommerce_existing_total_ht|formatNumber }} / {{ ecommerce_count - ecommerce_existing_count }}</strong>
                      </div>
                      -->

                    </div>
                  </div>

                  <div style="margin-top: 15px;">
                    <span class="data-legend"><i style="background:#dd207d;"></i> Montants annulés</span>
                    <div style="display:flex;flex-direction:column;">
                      <div class="data-label small" v-if="is_ttc">
                        <strong><i class="currency">{{ currency }}<span>TTC</span></i> {{ total_canceled|formatNumber }}</strong>
                      </div>
                      <div class="data-label small" v-if="!is_ttc">
                        <strong><i class="currency">{{ currency }}<span>HT</span></i> {{ total_canceled_ht|formatNumber }}</strong>
                      </div>
                    </div>
                  </div>

                  <div style="margin-top: 15px;">
                    <span class="data-legend"><i style="background:#cccccc;"></i> Montants brouillons</span>
                    <div style="display:flex;flex-direction:column;">
                      <div class="data-label small" v-if="is_ttc">
                        <strong><i class="currency">{{ currency }}<span>TTC</span></i> {{ total_draft|formatNumber }}</strong>
                      </div>
                      <div class="data-label small" v-if="!is_ttc">
                        <strong><i class="currency">{{ currency }}<span>HT</span></i> {{ total_draft_ht|formatNumber }}</strong>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
        </div>
    </div>
</template>
<script>

    import InvoiceService from './InvoiceService.js';
    import Bar from '../../../components/chart/Spline.vue'

    export default {
        name: 'Widget',
        components: {
            'chart' : Bar
        },
        props: ['title','period','className','branch'],
        data () {
            return {
                periods: [
                    {id: 'last_7days', label: '7 derniers jours'},
                    {id: 'current_month', label: 'Ce mois'},
                    {id: 'last_month', label: 'Le mois dernier'},
                    {id: 'since_1_month', label: '30 derniers jours'},
                    {id: 'since_3_months', label: '90 derniers jours'},
                    {id: 'current_year', label: 'Cette année'},
                    {id: 'last_year', label: 'Depuis 12 mois'},
                    {id: 'all', label: 'Tout'},
                    {id: 'custom', label: 'Personnalisé'},
                ],
                loaded: false,
                stats: {
                    dataset: null,
                    labels: null
                },
                dateFilter: {
                    start_at: '',
                    end_at: '',
                },
                showAdvancedFilterVue: false,
                is_ttc: true,
                count: null,
                total: null,
                currency: null,
                taxName: null,
                options: {
                    layout: {
                        padding: {
                            left: 0,
                            right: 10,
                            top: 0,
                            bottom: 0
                        }
                    },
                    scales: {
                        xAxes: [ {
                            categoryPercentage: 0.9,
                            barPercentage: 0.9,
                            stacked: false,
                            steppedLine: true,
                            gridLines: {
                                offsetGridLines: false,
                                display: false,
                                color: "#dddddd",
                                drawBorder: false
                            },
                            ticks: {
                                display: true,
                                fontColor: "#aaaaaa",
                                fontSize: 12,
                            },
                        }],
                        yAxes: [ {
                            stacked: false,
                            steppedLine: true,
                            gridLines: {
                                offsetGridLines: true,
                                display: true,
                                color: "#dddddd",
                                borderDashOffset: 1,
                                borderDash: [2,2],
                                drawBorder: false
                            },
                            ticks: {
                                fontColor: "#aaaaaa",
                                fontSize: 12,
                                display: true,
                                padding: 0
                                //stepSize: 1,
                                //suggestedMax: 0,
                                //suggestedMin: 0
                            }
                        }]
                    }
                }
            }
        },
        mounted: function(){

            this.currency = this.$store.state.scope.currency_id
            this.is_ttc = this.$store.state.scope.is_ttc
            this.period = this.period ? this.period : this.periods[0].id

            if(this.period == 'custom') {
                this.showAdvancedFilterVue = true
            }else{
                this.showAdvancedFilterVue = false;
            }

            this.filterByPeriod(this.period);

        },
        watch: {
            'dateFilter.start_at'(newVal, oldVal) {
                if(newVal != '' && this.dateFilter.end_at != ''){
                    this.filterByPeriodAndByDate(this.period, this.dateFilter);
                }
            },
            'dateFilter.end_at'(newVal, oldVal) {
                if(newVal != '' && this.dateFilter.start_at != ''){
                    this.filterByPeriodAndByDate(this.period, this.dateFilter);
                }
            }
        },
        methods: {
            filterByPeriod: function(period)
            {

                if(period == 'custom') {
                    this.showAdvancedFilterVue = true
                }else{
                    this.showAdvancedFilterVue = false;
                }

                if(period != 'custom') {

                    this.loaded = false;
                    this.period = period

                  InvoiceService.getStatsResume( this.period, this.branch ).then((response) => {

                      this.setResults(response);

                    }).catch((response) => {
                        console.log("error", response);
                        this.loaded = true;
                    })

                }
            },
            filterByPeriodAndByDate: function(period, dateFilter)
            {
                this.loaded = false;

                this.period = period
                this.date = JSON.stringify(dateFilter);

              InvoiceService.getStatsResume( this.period, this.branch, this.date ).then((response) => {

                  this.setResults(response);

                }).catch((response) => {
                    console.log("error", response);
                    this.loaded = true;
                })
            },
            setResults: function(response)
            {
              this.count = response.data.count
              this.count_compare = response.data.count_compare

              this.total = response.data.total
              this.total_ht = response.data.total_ht
              this.total_compare = response.data.total_compare
              this.total_compare_ht = response.data.total_compare_ht

              this.total_paied = response.data.paied
              this.total_paied_ht = response.data.paied_ht
              this.total_pending = response.data.pending
              this.total_pending_ht = response.data.pending_ht
              this.total_canceled = response.data.canceled
              this.total_canceled_ht = response.data.canceled_ht
              this.total_draft = response.data.draft
              this.total_draft_ht = response.data.draft_ht

              this.direct_total = response.data.sales.direct.total
              this.direct_total_ht = response.data.sales.direct.total_ht

              this.ecommerce_total = response.data.sales.ecommerce.total
              this.ecommerce_total_ht = response.data.sales.ecommerce.total_ht

              this.ecommerce_count = response.data.sales.ecommerce.count
              this.ecommerce_existing_count = response.data.sales.ecommerce.count_existing
              this.ecommerce_existing_total = response.data.sales.ecommerce.total_existing
              this.ecommerce_existing_total_ht = response.data.sales.ecommerce.total_existing_ht

              this.percentage_canceled = (response.data.canceled * 100) / (this.total + this.total_canceled)
              this.percentage_pending = (response.data.pending * 100) / (this.total + this.total_canceled)
              this.percentage_paied = ((response.data.paied * 100) / (this.total + this.total_canceled))
              this.percentage_is_web = (response.data.sales.ecommerce.total) * 100 / this.total

              this.pieChart = [
                {color:'#86d055', background:'#f7d46b', value: this.percentage_paied},
                {color:'#c051ff', background:'#67b2ff', value: this.percentage_is_web}
              ];

              this.loaded = true;
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/modules/invoicing/invoice/StatsResumeWidget.vue